import React from "react";

import musrik from "../assets/vow1.mp3";
import ReactAudioPlayer from "react-audio-player";

import Main from "./Main";
import Quote1 from "./Quote1";
import Quote2 from "./Quote2";
import Event from "./Event";
import Maps from "./Maps";

import leftOrnament from "../assets/splash-2.png";
import rightOrnament from "../assets/splash-1.png";
import GalleryThumb from "./GalleryThumb";

import Wishes from "./Wishes";

export default function Home() {
  return (
    <>
      <div className="left-ornament">
        <img
          src={leftOrnament}
          style={{ objectFit: "contain" }}
          width="180px"
        />
      </div>
      <div className="right-ornament">
        <img
          src={rightOrnament}
          style={{ objectFit: "contain" }}
          width="180px"
        />
      </div>

      <Main />
      <div style={{ height: 10 }} />
      <Quote1 />
      <div style={{ height: 20 }} />
      <Quote2 />
      <div style={{ height: 20 }} />
      <Event />
      <div style={{ height: 10 }} />
      <Maps />
      <div style={{ height: 10 }} />
      <GalleryThumb />
      <div style={{ height: 60 }} />
      <Wishes />
      <div
        style={{
          color: "whitesmoke",
          backgroundColor: "black",
          width: "100%",
          padding: "10px 0px",
          fontSize: 14,
        }}
      >
        created by{" "}
        <a
          href="https://www.instagram.com/ganangbp/"
          target="_blank"
          style={{ color: "hotpink" }}
        >
          ©jabu
        </a>{" "}
        <br />
        <br />
        ♥♥♥ (╭￣3￣)╭
      </div>
      <ReactAudioPlayer
        src={musrik}
        loop
        autoPlay
        // controls
        volume={0.8}
      />
    </>
  );
}
